module.exports = __webpack_public_path__ + "static/img/axial-caldera-accessible-colorbar.6fc91eb.png";